/**
 * Global hero skeleton for non-home pages.
 * Displays a skeleton placeholder matching the hero section height.
 */
export function HeroSkeleton() {
  return (
    <div className="bg-[rgb(132,137,116)] py-16 lg:py-40 px-4 lg:px-0 animate-pulse">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Mobile skeleton */}
          <div className="lg:hidden text-center">
            {/* Title skeleton */}
            <div className="h-8 bg-white/20 rounded-md w-3/4 mx-auto mb-4" />
            {/* Subtitle skeleton lines */}
            <div className="space-y-2 sm:w-2/3 mx-auto mb-6">
              <div className="h-4 bg-white/15 rounded-md w-full" />
              <div className="h-4 bg-white/15 rounded-md w-5/6 mx-auto" />
            </div>
            {/* Button skeletons */}
            <div className="flex flex-col gap-3 sm:w-1/2 mx-auto">
              <div className="h-10 bg-white/20 rounded-md w-full" />
              <div className="h-10 bg-white/20 rounded-md w-full" />
              <div className="h-10 bg-white/10 rounded-md w-full border border-white/20" />
            </div>
          </div>

          {/* Desktop skeleton */}
          <div className="hidden lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
            <div>
              {/* Title skeleton */}
              <div className="h-10 bg-white/20 rounded-md w-full mb-4" />
              <div className="h-10 bg-white/20 rounded-md w-3/4 mb-4" />
              {/* Subtitle skeleton lines */}
              <div className="space-y-2">
                <div className="h-5 bg-white/15 rounded-md w-full" />
                <div className="h-5 bg-white/15 rounded-md w-5/6" />
              </div>
            </div>
            <div className="flex flex-col gap-3 mx-auto px-4 w-full max-w-sm">
              <div className="h-10 bg-white/20 rounded-md w-full" />
              <div className="h-10 bg-white/20 rounded-md w-full" />
              <div className="h-10 bg-white/10 rounded-md w-full border border-white/20" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
